export const UserDefinedTypeName = {
  print: ({ node }) => node.namePath
};
